namespace $.$$ {
	
	$mol_style_define( $mol_emoji_safe_demo, {
		
		Scroll: {
			padding: $mol_gap.block,
		},
		
		Group: {
			margin: $mol_gap.block,
			padding: $mol_gap.block,
			background: {
				color: $mol_theme.card,
			},
		},
		
		Group_title: {
			textShadow: '0 0',
		},
		
		Emojis: {
			flex: {
				wrap: 'wrap',
			},
		},
		
		Emoji: {
			padding: $mol_gap.block,
		},
		
	} )
	
}
